module.exports = __webpack_public_path__ + "img/logo-haio.6734345e.png";